import { registerUploadHandler } from './registry'
import orthophotoUploadHandler from './handlers/orthophoto'

registerUploadHandler('orthophoto', orthophotoUploadHandler)
